/* eslint-disable */
import { StyleSheet } from 'react-native'
import { Fonts } from '../../Themes'
export default StyleSheet.create({
  container: {
    flex: 1,

  },
  center:{
    justifyContent: `center`
  },
  shadow: {
    // shadowColor: '#000000',
    // shadowOffset: { width: 2, height: 3 },
    // shadowOpacity: 0.5,
    // shadowRadius: 3,
    // elevation: 1,
  
  },
  whiteText: {
    color: `white`
  },
  tokenText: {
    color: `orange`
  },
  close: {
    width: 20,
    height: 20,
    alignItems: `center`,
    justifyContent: 'center',
    alignSelf: `center`
  },
  middle: {
   height:40,
    maxWidth: 170,
    padding: 5,
   justifyContent: `space-between`
  },
  content: {
    flex: 1,
    flexDirection: `row`,
    backgroundColor: `#FFFFFF`,
    borderRadius: 5,
    alignItems: `center`,
    padding: 5,
  },
  image: {
    height: 30,
    width: 30,
    borderRadius: 3
  },
  text: {
    fontFamily: Fonts.style.font.bold,
    color: `black`,
    fontSize: 12,
  },
  price: {
    fontFamily: Fonts.style.font.regular,
    fontSize: 10
  },
  triangle: {
    width: 0,
    height: 0,
    backgroundColor: 'transparent',
    borderStyle: 'solid',
    borderLeftWidth: 10,
    borderRightWidth: 10,
    borderBottomWidth: 10,
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    borderBottomColor: `#FFFFFF`,
    transform: [
      { rotate: '180deg' }
    ],
    alignSelf: `center`
  }
})
